import { render, staticRenderFns } from "./CommunityInner.vue?vue&type=template&id=47acca77&"
import script from "./CommunityInner.vue?vue&type=script&lang=js&"
export * from "./CommunityInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports